export default __webpack_public_path__ + "static/media/hear-white2.a907721b.svg";